import React from 'react';
import { ReportStatGroup } from './report-stat-group';
import { ReportStatItem } from './report-stat-item';
import { useT } from '../../utils/helper';
import { Stat } from '../../api/types/cash-register/cash-point-closing.types';
import { CartTypeStats } from './cart-type-stats';

/**
 * ReportRevenueAfterCancellation Component
 *
 * This component renders total nets, taxes, and totals stats.
 * Additionally, it conditionally renders cart type stats and the total tip amount if available.
 */
interface ReportRevenueAfterCancellationProps {
  stat: Stat;
}

export const ReportRevenueAfterCancellation = (
  props: ReportRevenueAfterCancellationProps,
) => {
  const t = useT('screens', { keyPrefix: 'CashPointClosing' });

  return (
    <ReportStatGroup title={t('revenueAfterCancellation').toString()}>
      {['total_nets', 'taxes', 'totals'].map(key => (
        <ReportStatItem key={key} title={t(key)} value={props.stat[key]} />
      ))}

      {props.stat.cart_type_stats ? (
        <CartTypeStats stats={props.stat.cart_type_stats} />
      ) : null}

      {props.stat.total_tip_amount ? (
        <ReportStatItem
          title={t('totalTipAmount')}
          value={props.stat.total_tip_amount}
        />
      ) : null}
    </ReportStatGroup>
  );
};
